import { ApplicationInsights, IProcessTelemetryContext, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import EnvWindow from './utils/env';

export class MockReactPlugin extends ReactPlugin {
  // eslint-disable-next-line
  processTelemetry(env: ITelemetryItem, itemCtx?: IProcessTelemetryContext): void {
    return; // when appinsights is turned off dont send any data
  }
}
const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    disableTelemetry: EnvWindow.REACT_APP_APPINSIGHTS_DISABLED,
    connectionString: EnvWindow.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
